import type { ComparisonValue } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { Operator } from '../operator'

import { Equal } from './equal'

const FactValueSchema = z.unknown().array().optional()

export class NotContain extends Operator<unknown[]> {
  private readonly equalOperator = new Equal()

  constructor() {
    super(LOGIC_OPERATOR.NOT_CONTAIN, FactValueSchema)
  }

  evaluate(
    factValue: z.infer<typeof FactValueSchema>,
    comparisonValue: ComparisonValue
  ): boolean {
    // if the factValue is undefined, we assume a match (therefore true)
    // this is currently needed for multi-select blocks when no options have been selected
    if (!factValue) return true

    if (Array.isArray(comparisonValue)) {
      return comparisonValue.every(
        (v) =>
          factValue.findIndex((factElement) =>
            this.equalOperator.evaluate(factElement, v)
          ) === -1
      )
    }

    return factValue.indexOf(comparisonValue) === -1
  }
}
